
import { defineComponent as _defineComponent } from "vue";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
import BlogCard from "@lakinduhewa/vue-js.ui.blog-card";
import { useGetBlogs } from "@lakinduhewa/vue-js.composable.blogs";
const __sfc__ = _defineComponent({
    __name: 'blog-list',
    setup(__props) {
        const blogs = useGetBlogs();
        return (_ctx, _cache) => {
            return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(blogs), (blog) => {
                return (_openBlock(), _createBlock(_unref(BlogCard), {
                    key: blog.title,
                    title: blog.title,
                    description: blog.description
                }, null, 8 /* PROPS */, ["title", "description"]));
            }), 128 /* KEYED_FRAGMENT */));
        };
    }
});
//# sourceMappingURL=module.js.map



export default __sfc__

//# sourceMappingURL=blog-list.vue.js.map